import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";

const GlobalSelect = ({
  className,
  defaultOption,
  name,
  onChange,
  items = [
    {
      value: "option1",
      label: "Option 1",
    },
    {
      value: "option2",
      label: "Option 2",
    },
    {
      value: "option3",
      label: "Option 3",
    },
  ],
  disabled = false,
  value,
  id = "select",
  placeholder = "",
  parentClassName,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    defaultOption || items[0] === undefined ? "" : items[0].value,
  );

  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value);
    onChange(e);
  };

  useEffect(() => {
    // if (value) {
    setSelectedOption(value || "");
    // }
  }, [value]);

  return (
    <div className={`${parentClassName}`}>
      <Dropdown
        id={id}
        placeholder={placeholder}
        disabled={disabled}s
        defaultValue={defaultOption}
        options={items}
        value={selectedOption}
        size={`small`}
        onChange={handleSelectChange}
        name={name}
        className={`p-inputtext-sm w-full border border-gray-400 font-montserrat ${className} ${
          disabled ? "cursor-not-allowed" : ""
        }`}
        appendTo={document.body}
      ></Dropdown>
    </div>
  );
};

export default GlobalSelect;
